export default "__VITE_ASSET__ggKMmHyt__"